import { render, staticRenderFns } from "./ReviewModalGallery.vue?vue&type=template&id=3fb01c86&scoped=true&"
import script from "./ReviewModalGallery.vue?vue&type=script&lang=js&"
export * from "./ReviewModalGallery.vue?vue&type=script&lang=js&"
import style0 from "./ReviewModalGallery.vue?vue&type=style&index=0&id=3fb01c86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb01c86",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiZoomImage: require('/app/components/UI/UiZoomImage.vue').default,UiSwiperCarousel: require('/app/components/UI/UiSwiperCarousel.vue').default})
